import { Injectable, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { ColumnFilterLoader } from '../models/column-filter-loader';
import { ColumnFilterDefinition } from '../models/column-filter-definition';
import { FilterSessionService } from './filter-session.service';
import { SessionStorageService } from '@core/session-storage.service';
import { ColumnFilterState } from '../models/column-filter-state';
import { PlainObject } from 'odata-query';

@Injectable()
export class InitialFilterLoaderService {
  private readonly session = inject(SessionStorageService);
  private readonly filterSession = inject(FilterSessionService);

  allFiltersLoaded$ = new Subject<void>();
  private externalFiltersLoaders: ColumnFilterState<unknown>[] = [];
  private isRefreshOrInit: boolean = false;

  addExternalFilter(
    externalFilterDefinition: ColumnFilterState<unknown>
  ): void {
    this.externalFiltersLoaders.push(externalFilterDefinition);
  }

  getExternalQuery(): PlainObject {
    const externalQuery: Partial<{ filter: PlainObject }> = {};
    this.externalFiltersLoaders.forEach(columnState => {
      if (columnState.hasValue()) {
        columnState.columnQueryBuilder!(columnState, new Map());
        const query = columnState.getQuery();
        externalQuery['filter'] = { ...query['filter'], ...query };
      }
    });
    return externalQuery;
  }

  startSession(columns: ColumnFilterDefinition[], sessionKey?: string): void {
    if (!this.isRefreshOrInit) {
      if (sessionKey) {
        this.session.remove(sessionKey);
      }
      this.isRefreshOrInit = true;
    }

    if (sessionKey) {
      this.filterSession.defineSession(sessionKey);
    }

    columns.forEach((column: ColumnFilterDefinition) => {
      column.filterLoaded.subscribe(() => {
        this.triggerFirstQuery(columns);
        column.filterLoaded.complete();
      });
    });
  }

  private triggerFirstQuery(columns: ColumnFilterLoader[]): void {
    const hasIncompleteCharge = columns.some(
      (column: ColumnFilterLoader) => !column.isLoaded
    );
    const hasIncompleteExtraCharge = this.externalFiltersLoaders.some(
      (column: ColumnFilterState<unknown>) => !column.isLoaded
    );

    if (!hasIncompleteCharge && !hasIncompleteExtraCharge) {
      this.externalFiltersLoaders.forEach(externalFilter => {
        if (externalFilter.checkSessionFn) {
          externalFilter.checkSessionFn();
        }
      });
      this.allFiltersLoaded$.next();
    }
  }

  reset(): void {
    this.externalFiltersLoaders = [];
  }
}
